export default __webpack_public_path__ + "static/kodnessPresentation-4b198fb7a23a2a24437570d6fa2250be.mp4";